import { aboutpricing } from "@/data/features";
import React from "react";

export default function Benefits() {
  return (
    <div className="container position-relative">
      {/* Grid */}
      <div className="row">
        {/* Text */}
        {/* <div className="col-md-12 col-lg-3 mb-md-50">
          <h2 className="section-caption mb-xs-10">Pricing</h2>
          <h3 className="section-title-small mb-40">Simplest Pricing, All the Features You Need</h3>
          <div className="section-line" />
        </div> */}
        <div className="col-md-4 col-lg-3 d-flex align-items-stretch mb-sm-30">
          <div className="alt-features-item border-left mt-0">
            <div className="alt-features-icon">
              {/* <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
              >
                <path d="M21.62 20.196c1.055-.922 1.737-2.262 1.737-3.772 0-1.321-.521-2.515-1.357-3.412v-6.946l-11.001-6.066-11 6v12.131l11 5.869 5.468-2.917c.578.231 1.205.367 1.865.367.903 0 1.739-.258 2.471-.676l2.394 3.226.803-.596-2.38-3.208zm-11.121 2.404l-9.5-5.069v-10.447l9.5 4.946v10.57zm1-.001v-10.567l5.067-2.608.029.015.021-.04 4.384-2.256v5.039c-.774-.488-1.686-.782-2.668-.782-2.773 0-5.024 2.252-5.024 5.024 0 1.686.838 3.171 2.113 4.083l-3.922 2.092zm6.833-2.149c-2.219 0-4.024-1.808-4.024-4.026s1.805-4.025 4.024-4.025c2.22 0 4.025 1.807 4.025 4.025 0 2.218-1.805 4.026-4.025 4.026zm-.364-3.333l-1.306-1.147-.66.751 2.029 1.782 2.966-3.12-.725-.689-2.304 2.423zm-16.371-10.85l4.349-2.372 9.534 4.964-4.479 2.305-9.404-4.897zm9.4-5.127l9.404 5.186-3.832 1.972-9.565-4.98 3.993-2.178z" />
              </svg> */}

              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.19 7h2.81v15h-21v-5h-2.81v-15h21v5zm1.81 1h-19v13h19v-13zm-9.5 1c3.036 0 5.5 2.464 5.5 5.5s-2.464 5.5-5.5 5.5-5.5-2.464-5.5-5.5 2.464-5.5 5.5-5.5zm0 1c2.484 0 4.5 2.016 4.5 4.5s-2.016 4.5-4.5 4.5-4.5-2.016-4.5-4.5 2.016-4.5 4.5-4.5zm.5 8h-1v-.804c-.767-.16-1.478-.689-1.478-1.704h1.022c0 .591.326.886.978.886.817 0 1.327-.915-.167-1.439-.768-.27-1.68-.676-1.68-1.693 0-.796.573-1.297 1.325-1.448v-.798h1v.806c.704.161 1.313.673 1.313 1.598h-1.018c0-.788-.727-.776-.815-.776-.55 0-.787.291-.787.622 0 .247.134.497.957.768 1.056.344 1.663.845 1.663 1.746 0 .651-.376 1.288-1.313 1.448v.788zm6.19-11v-4h-19v13h1.81v-9h17.19z" /></svg>
            </div>
            <h3 className="alt-features-title">Affordable Pricing</h3>
            <div className="alt-features-descr">Cost-effective rates with no hidden fees, so you know exactly what you’re paying for.</div>
          </div>
        </div>
        {/* End Text */}
        <div className="col-md-4 col-lg-3 d-flex align-items-stretch mb-sm-30">
          <div className="alt-features-item border-left mt-0">
            <div className="alt-features-icon">
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22c-5.514 0-10-4.486-10-10S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm-1-15h2v6h-2V7zm0 8h2v2h-2v-2z" />
              </svg>

            </div>
            <h3 className="alt-features-title">No Hidden Fees</h3>
            <div className="alt-features-descr">Transparent pricing with no unexpected costs, so you know exactly what you're paying for.</div>
          </div>
        </div>

        <div className="col-md-4 col-lg-3 d-flex align-items-stretch mb-sm-30">
          <div className="alt-features-item border-left mt-0">
            <div className="alt-features-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 19h-4v-8h4v8zm6 0h-4v-18h4v18zm6 0h-4v-12h4v12zm6 0h-4v-4h4v4zm1 2h-24v2h24v-2z"/></svg>

            </div>
            <h3 className="alt-features-title">Scalable Plans</h3>
            <div className="alt-features-descr">Choose from flexible plans that grow with your business, offering features you need as you expand.</div>
          </div>
        </div>

        <div className="col-md-4 col-lg-3 d-flex align-items-stretch mb-sm-30">
          <div className="alt-features-item border-left mt-0">
            <div className="alt-features-icon">
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-3.31 0-6 2.69-6 6v1h12v-1c0-3.31-2.69-6-6-6zm-2 8h4v-1H10v1zm7-5h-2.5l-.5-.5v-1l-.5-.5H9l-.5.5v1l-.5.5H6v3h11v-3z" />
              </svg>

            </div>
            <h3 className="alt-features-title">Dedicated Account Manager</h3>
            <div className="alt-features-descr">Benefit from personalized support with dedicated account manager to assist your specific needs.</div>
          </div>
        </div>

        {/* Feature Item */}
        {/* {aboutpricing.map((item, index) => (
          <div key={index} className={item.className}>
            <div className="alt-features-item border-left mt-0">
              <div className="alt-features-icon">
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                  focusable="false"
                  xmlns="http://www.w3.org/2000/svg"
                  fillRule="evenodd"
                  clipRule="evenodd"
                >
                  <path d={item.path} />
                </svg>
              </div>
              <h4 className="alt-features-title">{item.title}</h4>
              <div className="alt-features-descr">{item.description}</div>
            </div>
          </div>
        ))} */}
        {/* End Feature Item */}
      </div>
      {/* End Grid */}
    </div>
  );
}
